<template>
  <div id="ReferralInstitutiont-edit">
    <IForm ref="formInline" :model="edit" :elem="editElem" :rules="editRule" :submit="false"  @on-submit="toSubmit">

      <div slot="extend">
        <Row>
          <Col span="24"><FormItem :label-width="60" label="名称" prop="name"><Input v-model="edit.name" type="text" placeholder="请输入名称" maxlength="125"/></FormItem></Col>
        </Row>
        <Row>
          <Col span="24">
            <FormItem :label-width="60" label="状态" prop="status">
              <RadioGroup prop="status" v-model="edit.status">
                <Radio v-for="item in statusList" v-bind:key="item.value" :label="item.value">{{item.label}}</Radio>
              </RadioGroup>
            </FormItem>
          </Col>
        </Row>
      </div>
    </IForm>
  </div>
</template>
<script>

import {_save, _get} from "@/services/screeningConfig/referralInstitutiont.js";
export default {
  name: "ReferralInstitutiontEdit",
  data() {
    return {
      edit: {
        name: "",
        errorConfigId: "",
        code: "",
        reason: "",
        propose: "",
        status: 1,
      },
      init: "",
      statusList:[
        {label: '启用', value: 1},
        {label: '停用', value: 2},
      ],
      editElem: [],
      editRule: {
        name: [
          {required: true, message: '名称不能为空', trigger: 'blur'},
        ],
      },
    };
  },
  mounted() {
    this.init = Object.assign({}, this.edit);
  },
  methods: {
    handleModal(row) {
      this.$refs["formInline"].handleReset();
      if (!row) {
        this.handleCreate();
      } else {
        this.handleEdit(row);
      }
      this.$forceUpdate();
    },
    handleCreate() {
      this.edit = Object.assign({}, this.init);
    },
    handleEdit(row) {
      _get({id: row.id}).then(res => {
        this.edit = Object.assign({}, res.data);
        this.$forceUpdate();
      })
    },
    handleSubmit() {
      this.$refs["formInline"].handleSubmit('form');
    },
    toSubmit() {
      _save(this.edit).then(res => {
        if (res.errcode === 1) {
          this.$message.success("保存成功");
          this.$emit("on-submit", false);
        }else{
          this.$message.error(res.errmsg);
        }
      }).catch(() => {});
    }
  }
};
</script>
<style lang="postcss" scoped>

</style>
